/* eslint-disable react/require-default-props,react/destructuring-assignment,prefer-destructuring */

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withTranslation } from 'react-i18next';
import {
  PortalPageSectionPropType,
  PortalInstitutionPropType,
  PortalQualificationPropType,
  PortalCoursePropType,
} from '../../../CustomPropTypes/PortalPropTypes';
import { PortalCourses } from './PortalCourses/PortalCourses';
import { PortalFaqs } from './PortalFaqs/PortalFaqs';
import { PortalTestimonials } from './PortalTestimonials/PortalTestimonials';
import { PortalOLPromoBlock } from './PortalOLPromoBlock/PortalOLPromoBlock';
import { PortalInstitutionSellingPoints } from './PortalInstitutionSellingPoints/PortalInstitutionSellingPoints';
import { PortalFreeToLearn } from './PortalFreeToLearn/PortalFreeToLearn';
import { PortalQualifications } from './PortalQualifications/PortalQualifications';
import { PortalQualificationCourseList } from './PortalQualificationCourseList/PortalQualificationCourseList';
import { PortalQualificationKeyInformation } from './PortalQualificationKeyInformation/PortalQualificationKeyInformation';
import { PortalQualificationSellingPoints } from './PortalQualificationSellingPoints/PortalQualificationSellingPoints';
import { PortalRichTextBlock } from './PortalRichTextBlock/PortalRichTextBlock';
import { PortalVideo } from './PortalVideo/PortalVideo';
import { PortalTeam } from './PortalTeam/PortalTeam';
import { PortalSubscriptionPlans } from './PortalSubscriptionPlans/PortalSubscriptionPlans';
import { PortalOutcomes } from './PortalOutcomes/PortalOutcomes';
import { PortalCommunity } from './PortalCommunity/PortalCommunity';
import { PortalMoreQualifications } from './PortalMoreQualifications/PortalMoreQualifications';
import { PortalPartnerInstitutions } from './PortalPartnerInstitutions/PortalPartnerInstitutions';
import { defaultStrings } from '../PortalShared';
import { PortalSubscriptionPayment } from './PortalSubscriptionPayment/PortalSubscriptionPayment';
import { PortalCategories } from './PortalCategories/PortalCategories';

class _PortalPageSection extends React.Component {
  static displayName = 'PortalPageSection';

  static propTypes = {
    expandFirstCourse: PropTypes.bool,
    onCtaButtonClicked: PropTypes.func,
    onEnrolInCourse: PropTypes.func,
    onEnrolInQualification: PropTypes.func,
    onFaqExpanded: PropTypes.func,
    onSubmitQualificationInterest: PropTypes.func,
    pageType: PropTypes.string.isRequired,
    portalInstitution: PortalInstitutionPropType.isRequired,
    qualification: PortalQualificationPropType,
    course: PortalCoursePropType,
    section: PortalPageSectionPropType.isRequired,
    defaultStrings: ImmutablePropTypes.map,
    isEnrolled: PropTypes.bool,
    getCoursesForCategory: PropTypes.func,
    t: PropTypes.func,
  };

  static defaultProps = { defaultStrings };

  static contextTypes = {
    strings: ImmutablePropTypes.map,
  };

  onCtaButtonClicked = (buttonText) => {
    if (buttonText) {
      this.props.onCtaButtonClicked(buttonText, this.props.section.get('name'));
    }
  };

  onEnrolInCourse = (...args) => {
    this.props.onEnrolInCourse(...args);
  };

  render() {
    const {
      onEnrolInQualification,
      onFaqExpanded,
      onSubmitQualificationInterest,
      pageType,
      portalInstitution,
      qualification,
      course,
      section,
      isEnrolled,
      getCoursesForCategory,
      t,
    } = this.props;
    const strings = this.props.defaultStrings.merge(this.context.strings);
    const expandFirstCourse = this.props.expandFirstCourse || false;
    const onEnrolInCourse = this.onEnrolInCourse;
    const onCtaButtonClicked = this.onCtaButtonClicked;
    const faqs = portalInstitution.get('faqs');
    const qualifications = portalInstitution.get('qualifications');
    const type = section.get('type');
    let title = section.get('title');
    const name = section.get('name');
    const data = section.get('data');
    const sectionRenderers = {
      community() {
        const anchor = name;
        const content = data.get('content');
        const community = data.get('community');
        if (community.get('usersCount', 0) > 0) {
          return <PortalCommunity {...{ anchor, title, content, community }} />;
        }
        return null;
      },

      yourCourses() {
        const anchor = name;
        const content = data.get('content');
        const courses = data.get('courses');
        return courses.size ? (
          <PortalCourses
            {...{ anchor, title, content, courses, onCtaButtonClicked }}
          />
        ) : null;
      },

      courses() {
        const anchor = name;
        const content = data.get('content');
        const courses = data.get('courses');
        return (
          <PortalCourses
            {...{ anchor, title, content, courses, onCtaButtonClicked }}
          />
        );
      },

      courseCategories() {
        const anchor = name;
        const content = data.get('content');
        const categories = data.get('categories', Immutable.List());
        return (
          <PortalCategories
            {...{
              anchor,
              title,
              content,
              categories,
              onCtaButtonClicked,
              getCoursesForCategory,
            }}
          />
        );
      },

      qualifications() {
        const anchor = name;
        const content = data.get('content');
        const titleImage = data.get('titleImage') || null;
        const titleImageSize = data.get('titleImageSize') || null;

        if (title === 'Get Certified') {
          title = t('get_certified');
        }

        return (
          <PortalQualifications
            {...{
              anchor,
              title,
              content,
              titleImage,
              titleImageSize,
              onCtaButtonClicked,
              qualifications,
            }}
            showCourses={false}
          />
        );
      },

      moreQualifications() {
        return (
          <PortalMoreQualifications
            onSubmit={onSubmitQualificationInterest}
            {...{ onCtaButtonClicked }}
          />
        );
      },

      freeToLearn() {
        const backgroundImageUrl = data.get('backgroundImageUrl');
        let showEnrolButton = false;
        const enrol = () => {
          if (_.isFunction(onEnrolInQualification)) {
            onEnrolInQualification(qualification);
          }
        };

        if (qualification) {
          if (qualification.get('isFreeToLearn')) {
            showEnrolButton = !qualification.get('isEnrolled');
            return (
              <PortalFreeToLearn
                {...{
                  backgroundImageUrl,
                  enrol,
                  onCtaButtonClicked,
                  qualification,
                  showEnrolButton,
                }}
              />
            );
          }
        } else {
          return <PortalFreeToLearn {...{ backgroundImageUrl }} />;
        }
        return null;
      },

      institutionSellingPoints() {
        const anchor = name;
        const sellingPoints = portalInstitution.get('sellingPoints');
        return (
          <PortalInstitutionSellingPoints
            {...{ anchor, title, sellingPoints }}
          />
        );
      },

      olPromoBlock() {
        return <PortalOLPromoBlock />;
      },

      outcomes() {
        const content = data.get('content');
        const outcomes = data.get('outcomes');
        const furtherInformation = data.get('furtherInformation');
        return (
          <PortalOutcomes
            anchor={name}
            {...{
              title,
              content,
              outcomes,
              furtherInformation,
              onEnrolInCourse,
              course,
              onCtaButtonClicked,
            }}
            showObjective={pageType === 'course'}
            objective={data.get('objective', '')}
          />
        );
      },

      team() {
        let teamData = Immutable.List();
        if (qualification) {
          if (qualification.hasIn(['teamPageSection', 'data', 'team'])) {
            teamData = qualification.getIn(['teamPageSection', 'data', 'team']);
          }
        } else {
          teamData = data.get('team');
        }

        let context = `for this ${strings.get('course')}`;
        if (pageType === 'institution' || pageType === 'qualification') {
          context = `at ${portalInstitution.get('institutionName')}`;
        }
        const defaultProfileSummary = `Hello everyone, I'm a teacher ${context} and I can't wait to learn with all of you.`;

        if (teamData.size > 0) {
          return (
            <PortalTeam
              anchor={name}
              {...{ title, teamData, defaultProfileSummary }}
            />
          );
        }
        return null;
      },

      testimonials() {
        let sectionData = Immutable.Map();
        if (qualification) {
          if (qualification.hasIn(['testimonialsPageSection', 'data'])) {
            sectionData = qualification.getIn([
              'testimonialsPageSection',
              'data',
            ]);
          }
        } else {
          sectionData = data;
        }
        const testimonials = sectionData.has('testimonials')
          ? sectionData.get('testimonials')
          : Immutable.List();
        const anchor = name;
        const enrol = () => {
          if (_.isFunction(onEnrolInQualification)) {
            onEnrolInQualification(qualification);
          }
        };

        if (testimonials.size > 0) {
          switch (pageType) {
            case 'institution':
              return (
                <PortalTestimonials
                  callToAction={t('common:get_started')}
                  {...{ pageType, anchor, testimonials, onCtaButtonClicked }}
                />
              );
            case 'qualification':
              return (
                <PortalTestimonials
                  callToAction={t('common:join_now')}
                  {...{
                    pageType,
                    anchor,
                    testimonials,
                    onCtaButtonClicked,
                    enrol,
                    qualification,
                  }}
                />
              );
            default:
              return (
                <PortalTestimonials {...{ pageType, anchor, testimonials }} />
              );
          }
        }
        return null;
      },

      faqs() {
        const faqsData = data.get('faqs') || faqs;
        const anchor = name;

        return <PortalFaqs {...{ anchor, faqsData, title, onFaqExpanded }} />;
      },

      partnerInstitutions() {
        const anchor = name;
        const partners = data.get('partners') || new Immutable.List();

        return <PortalPartnerInstitutions {...{ anchor, title, partners }} />;
      },

      qualificationCourseList() {
        const anchor = name;
        const qualificationSection = qualification.get(
          'qualificationCourseListPageSection'
        );
        let blurb = '';
        if (
          qualificationSection &&
          qualificationSection.hasIn(['data', 'blurb'])
        ) {
          blurb = qualificationSection.getIn(['data', 'blurb']);
        }
        if (qualificationSection && qualificationSection.has('title')) {
          title = qualificationSection.get('title');
        }

        return (
          <PortalQualificationCourseList
            {...{
              anchor,
              title,
              blurb,
              qualification,
              onEnrolInCourse,
              onCtaButtonClicked,
              expandFirstCourse,
            }}
          />
        );
      },

      qualificationKeyInformation() {
        const anchor = name;
        const onCallToAction = onEnrolInQualification;
        return (
          <PortalQualificationKeyInformation
            {...{ anchor, qualification, onCallToAction, onCtaButtonClicked }}
          />
        );
      },

      qualificationSellingPoints() {
        const anchor = name;
        const qualificationSection = qualification.get(
          'qualificationSellingPointsPageSection'
        );
        let blurb = '';
        if (
          qualificationSection &&
          qualificationSection.hasIn(['data', 'blurb'])
        ) {
          blurb = qualificationSection.getIn(['data', 'blurb']);
        }
        let sellingPoints = Immutable.List();
        if (
          qualificationSection &&
          qualificationSection.hasIn(['data', 'sellingPoints'])
        ) {
          sellingPoints = qualificationSection.getIn(['data', 'sellingPoints']);
        }
        if (qualificationSection && qualificationSection.has('title')) {
          title = qualificationSection.get('title');
        }

        if (sellingPoints.size > 0) {
          return (
            <PortalQualificationSellingPoints
              {...{ anchor, title, blurb, sellingPoints }}
            />
          );
        }
        return null;
      },

      richTextBlock() {
        const anchor = name;
        let blurb = data.get('summary', '');
        let content = data.get('content', '');
        if (qualification) {
          title = qualification.getIn(
            ['richTextBlockPageSection', 'title'],
            ''
          );
          blurb = qualification.getIn(
            ['richTextBlockPageSection', 'data', 'summary'],
            ''
          );
          content = qualification.getIn(
            ['richTextBlockPageSection', 'data', 'content'],
            ''
          );
        }
        const displayBlock = blurb || content;

        return displayBlock ? (
          <PortalRichTextBlock {...{ anchor, title, blurb, content }} />
        ) : null;
      },

      video() {
        // only used for qualification pages
        const anchor = name;
        if (qualification.hasIn(['videoPageSection', 'data', 'videoUrl'])) {
          const videoUrl = qualification.getIn([
            'videoPageSection',
            'data',
            'videoUrl',
          ]);
          return <PortalVideo {...{ anchor, videoUrl }} />;
        }
        return null;
      },

      subscriptionPayment() {
        const subscriptionPaymentUrl = portalInstitution.get(
          'subscriptionPaymentUrl'
        );
        const onClick = () => {
          // TODO: fix this to use redux action and routesMap
          window.location.href = subscriptionPaymentUrl;
        };
        if (subscriptionPaymentUrl) {
          return (
            <PortalSubscriptionPayment
              {...{ onClick, isEnrolled, onCtaButtonClicked }}
            />
          );
        }
        return null;
      },

      subscriptionPlans() {
        const themeData = portalInstitution.get('themeData');
        return <PortalSubscriptionPlans {...{ title, data, themeData }} />;
      },
    };

    if (sectionRenderers[type]) {
      return sectionRenderers[type]();
    }

    return <div>{type}</div>;
  }
}

export const PortalPageSection = withTranslation(['common', 'landingPages'])(
  _PortalPageSection
);
